import { render, staticRenderFns } from "./Partners_m.vue?vue&type=template&id=579cca6d&scoped=true&"
import script from "./Partners_m.vue?vue&type=script&lang=js&"
export * from "./Partners_m.vue?vue&type=script&lang=js&"
import style0 from "./Partners_m.vue?vue&type=style&index=0&id=579cca6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579cca6d",
  null
  
)

export default component.exports